import { Button, Col, Container, Form, Offcanvas, Row } from "react-bootstrap";
// import HomeLogo from "../assets/images/grub-home-logo.png";
// import Banner from "../assets/images/layer_2_2.png";
// import layer2 from "../assets/images/layer_2.png";
// import element2 from "../assets/images/elements.png";
// import layer3 from "../assets/images/layer_3.png";
// import layer7 from "../assets/images/layer_7.png";
// import layer8 from "../assets/images/7.png";
import Logo from "../../assets/img/logo.png";
import WebBanne from "../../assets/img/website-banner.png";
import DigitalBanner from "../../assets/img/dm-banner.png";
import line from "../../assets/img/line.png";
import WebsiteForm from "../Website/Form"
import { IoMail } from "react-icons/io5";
import { IoIosCall } from "react-icons/io";
import {
    FaFacebookF,
    FaFacebookSquare,
    FaInstagram,
    FaInstagramSquare,
    FaLinkedinIn,
    FaPhoneSquareAlt,
    FaWhatsapp,
    FaWhatsappSquare,
    FaYoutubeSquare,
} from "react-icons/fa";
// import RestaurantListing from "../assets/images/services/checklist.png";
// import DigitalMenu from "../assets/images/services/Digital-Menu.png";
// import OnlineOrdering from "../assets/images/services/Online-Ordering.png";
// import DigitalMarketing from "../assets/images/services/Digital-Marketing.png";
// import PhotoVideo from "../assets/images/services/Photo-Videography.png";
// import JobRecruitment from "../assets/images/services/Jobs-Recruitment.png";
// import SourceMarketplace from "../assets/images/services/Sourcing-Marketplace.png";
// import FormBg from "../assets/images/form-bg.png";
// import PenguinTop from "../assets/images/top-icon.png";
import { MdLocationPin } from "react-icons/md";
import { useEffect, useState } from "react";
// import Notiflix from "notiflix";
// import { BsArrowRepeat } from "react-icons/bs";
// import PostApiCall from "../helper/Api";
// import "react-phone-number-input/style.css";
// import PhoneInput from "react-phone-number-input";
import "./VisitingCard.css"
import { VscFeedback } from "react-icons/vsc";
import { FiChevronUp } from "react-icons/fi";
import moment from "moment";
export default function VisitingCard() {
    const [scroll, setScroll] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            setScroll(window.scrollY > 0);
        });
    }, []);
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    }
    const handleShow = () => setShow(true);
    return (
        <>
            <div className="home-page-outer">
                <section className="home-page">
                    <div className="top-section">
                        <Container fluid>
                            <Row>
                                <Col>
                                    <div>
                                        <div className="my-2 www text-center">
                                            <a
                                                href="https://globaltrendz.com/"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-white text-center fw-bold">
                                                www.globaltrendz.com
                                            </a>
                                        </div>
                                        <div className="mx-1 mb-2 position-relative">
                                            <div className="d-flex ms-lg-4 justify-content-between justify-content-lg-center align-items-center">
                                                <h1 className="mb-0">
                                                    <div className="text-dark font">
                                                        Take Your Brand <br /> to New Heights
                                                    </div>
                                                    <div className="text-white font">
                                                        with Digital Excellence!
                                                    </div>
                                                </h1>
                                                <div className="logo-box ms-auto mb-0">
                                                    <img
                                                        src={Logo}
                                                        alt="Global Trendz Logo"
                                                        loading="lazy"
                                                        className="img-fluid"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                    <div className="service-section pt-3 mt-2 mb-4">
                        <Container fluid>
                            <Row>
                                <Col>
                                    <div className="section-head">
                                        <h2 className="text-dark mb-2">
                                            Let's help you <span className="text-theme">promote</span>{" "}
                                            your business
                                        </h2>
                                    </div>
                                </Col>
                            </Row>

                            <div className="row chinki py-3">
                                <div className="col-6 position-relative">
                                    <img
                                        src={DigitalBanner}
                                        className="img-fluid banner"
                                        loading="lazy"
                                        alt="banner"
                                    />
                                    {/* <img
                                        // src={layer8}
                                        className="img-fluid element-one"
                                        loading="lazy"
                                        alt="Grub Digest Penguin"
                                    /> */}
                                </div>
                                <div className="col-6 my-3 position-relative">
                                    {/* <img
                                        src={line}
                                        className="img-fluid line-one"
                                        loading="lazy"
                                        alt="line"
                                    /> */}

                                    <h2>
                                        Elevate Your Brand with Digital Marketing!
                                    </h2>
                                    <div>
                                        <h4>
                                            Search Engine <span>Optimization</span>
                                            {/* <span> (SEO)</span> */}
                                        </h4>
                                        <span>Rank higher & get organic traffic effortlessly</span>
                                    </div>
                                    <div>
                                        <h4>
                                            Search Engine <span>Marketing</span>
                                            {/* <span> (SEM)</span> */}
                                        </h4>
                                        <span>Get instant visibility with targeted search ads</span>
                                    </div>
                                    <div>
                                        <h4>
                                            Social Media <span>Marketing</span>
                                            {/* <span> (SMM)</span> */}
                                        </h4>
                                        <span>Engage, grow & build a loyal audience</span>
                                    </div>
                                    <div className="extra-text">
                                        <h4>
                                            Paid
                                            <span> Ads</span>
                                        </h4>
                                        <span>Maximize reach & conversions with strategic advertising</span>
                                    </div>
                                    <div>
                                        <h4>
                                            <span>Graphic</span> Design
                                        </h4>
                                        <span>Create visually stunning graphics for your brand</span>
                                    </div>
                                    <div>
                                        <h4>
                                            Photography &  <span> Videography</span>
                                        </h4>
                                        <span>Capture compelling visuals that tell your story</span>
                                    </div>
                                    <div className="extra-text">
                                        <h4>
                                            <span>Video</span> Editing
                                        </h4>
                                        <span>Transform raw footage into engaging video content
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-4 minki py-3">
                                <div className="col-6 text-end position-relative">
                                    <h2>
                                        {/* <img
                                            src={line}
                                            className="img-fluid line-two"
                                            loading="lazy"
                                            alt="line"
                                        /> */}
                                        Want Future Ready Web & Mobile Solutions?
                                    </h2>
                                    <div>
                                        <div className="d-flex gap-1 justify-content-end free">
                                            {/* <img
                                                // src={layer7}
                                                className="img-fluid" alt="Free Icon" /> */}
                                            <h4>
                                                <span>Web Application </span>
                                                Development
                                            </h4>
                                        </div>
                                        <span>
                                            Scalable & secure solutions
                                        </span>
                                    </div>
                                    <div>
                                        <div className="d-flex gap-1 justify-content-end free">
                                            {/* <img
                                                // src={layer7}
                                                className="img-fluid"
                                                loading="lazy"
                                                alt="Free Icon"
                                            /> */}

                                            <h4>
                                                Website <br />
                                                <span>Design & Development</span>
                                            </h4>
                                        </div>
                                        <span>
                                            Stunning & high-performance sites
                                        </span>
                                    </div>
                                    <div>
                                        <h4>
                                            e-Catalogues & <br /><span> e-Brochures </span>
                                        </h4>
                                        <span>
                                            Digital showcase made easy
                                        </span>
                                    </div>
                                    <div>
                                        <h4>
                                            <span>Mobile Application</span> Development
                                        </h4>
                                        <span>
                                            Smart & user-friendly apps
                                        </span>
                                    </div>
                                    <div>
                                        <h4>
                                            Progressive
                                            <span> Web Applications</span>
                                        </h4>
                                        <span>
                                            Fast, reliable & engaging
                                        </span>
                                    </div>
                                    <div>
                                        <h4>

                                            <span>UI & UX</span> Design
                                        </h4>
                                        <span>
                                            Intuitive & seamless experience
                                        </span>
                                    </div>
                                </div>
                                <div className="col-6 position-relative">
                                    <img
                                        src={WebBanne}
                                        className="img-fluid banner"
                                        loading="lazy"
                                        alt="Grub Owner Image "
                                    />
                                    {/* <img
                                        // src={element2}
                                        className="img-fluid element-two"
                                        loading="lazy"
                                        alt="Grub Digest Penguin"
                                    /> */}
                                </div>
                            </div>
                        </Container>
                    </div>
                    <div className="form-section pb-3 mb-3">
                        <Container fluid>
                            <Row>
                                <Col>
                                    <div className="section-head">
                                        <h2 className="text-dark mb-2">
                                            Let's Talk <br />{" "}
                                            <span className="d-inline-block mt-1">
                                                <a href="tel:+919821900322">+91 98219 00322</a>
                                            </span>
                                        </h2>
                                    </div>
                                </Col>
                            </Row>
                            <div className="d-flex flex-column gap-2 justify-content-between">
                                <div className="w-100">
                                    <h6 className="fw-bold">New Delhi</h6>
                                    <div className="">
                                        <p className="mb-1 ">
                                            Renit Daniel -{" "}
                                            <a href="tel:+919840093858">+91 98400 93858</a>
                                        </p>
                                        {/* <p className="mb-1 ">
                      Ruby Antil -{" "}
                      <a href="tel:+919821900322">+91 98219 00322</a>
                    </p> */}
                                    </div>
                                </div>
                                <div className="w-100">
                                    <h6 className="fw-bold">Chennai</h6>
                                    <p className="mb-2 ">
                                        Jonadab V - <a href="tel: +919008461111">  +91 90084 61111
                                        </a>
                                    </p>
                                    <p className="mb-2 ">
                                        Jackson S - <a href="tel:+918428663789"> +91 84286 63789
                                        </a>
                                    </p>
                                    {/* <p className="mb-2 ">
                                        Nithya Sri - <a href="tel:+917810001339">+91 78100 01339</a>
                                    </p>
                                    <p className="mb-2 ">
                                        Jackson S - <a href="tel:+918428663789">+91 84286 63789</a>
                                    </p> */}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="submit-button mt-3">
                                        <Button className="w-100" onClick={handleShow}>
                                            Get a Quote
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </Container>
                    </div>
                    <div className="footer-section py-3 mt-2 pb-0">
                        <Container fluid>
                            <Row>
                                {/*  */}
                                <div className="gap-3 mt-1 location-section justify-content-between">
                                    <div className="text-white mt-1">
                                        <h5>New Delhi</h5>
                                        <a
                                            href="https://maps.app.goo.gl/9VXyAzq5qvTTDE2n9"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            <MdLocationPin />
                                            <div className="d-flex flex-column">
                                                <span>S-7, 3rd Floor, Janta Market,<br /> Rajouri Garden, New Delhi 110027, INDIA</span>
                                            </div>
                                        </a>
                                        <p>
                                            <IoIosCall />{" "}
                                            <a href="tel:+911147037722">+91 11 4703 7722</a>
                                        </p>
                                    </div>
                                    <div className="text-white mt-1">
                                        <h5>Chennai</h5>
                                        <a
                                            href="https://maps.app.goo.gl/K6ePbECzfTuMi9f59"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            <MdLocationPin />
                                            <div className="d-flex flex-column">
                                                <span># 621, 3rd Floor, Sire Mansion, <br /> Anna Salai,</span>
                                                Chennai - 600 006, INDIA.
                                            </div>
                                        </a>
                                        <p>
                                            <IoIosCall />{" "}
                                            <a href="tel:+914443099119">+91 44 4309 9119</a>
                                        </p>
                                    </div>
                                    <p className=" text-white">
                                        <IoMail />{" "}
                                        <a href="mailto:info@globaltrendz.com">
                                            info@globaltrendz.com
                                        </a>
                                    </p>
                                    <p className="mb-0 text-white">
                                        <IoMail />{" "}
                                        <a href="mailto:sales@globaltrendz.com">
                                            sales@globaltrendz.com
                                        </a>
                                    </p>
                                </div>
                                <div className="border-top col-12 text-center  py-2 mt-3 pb-5 bg-dark">
                                    <p className="m-0 text-white position-relative z-3 mb-2">
                                        &copy; {moment().format("YYYY")} &nbsp;
                                        <a
                                            href="https://globaltrendz.com/"
                                            target="_blank"
                                            rel="noopener noreferrer">
                                            Global Trendz.
                                        </a>
                                        <br className="d-block d-lg-none" />
                                        &nbsp; All Rights
                                        Reserved.
                                    </p>
                                </div>
                            </Row>
                        </Container>
                    </div>
                </section>
                <div className="d-flex justify-content-between align-items-center float-icon pb-1">
                    <div className="d-flex gap-2 social-media-block position-static">
                        <a href="https://www.facebook.com/globaltrendz" target="_blank">
                            <FaFacebookF className="social-media-icon facebook" />
                        </a>
                        <a href="https://www.instagram.com/globaltrendz.india/" target="_blank">
                            <FaInstagram className="social-media-icon" />
                        </a>
                        <a href="https://www.linkedin.com/company/globaltrendz" target="_blank">
                            <FaLinkedinIn className="social-media-icon" />
                        </a>
                        <a
                            href="https://api.whatsapp.com/send?phone=+919821900322"
                            target="_blank">
                            <FaWhatsapp className="social-media-icon" />
                        </a>
                        {/* <a href="#" onClick={handleShow}> */}
                        <a href="/contact-us">
                            <VscFeedback className="social-media-icon" />
                        </a>
                    </div>
                    <button
                        onClick={() => {
                            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
                        }}
                        className={
                            scroll
                                ? "scroll-top show animate__animated animate__bounce"
                                : "scroll-top"
                        }>
                        {/* <img
                            // src={PenguinTop}
                            alt="Pengiun" loading="lazy" /> */}
                        <FiChevronUp />
                    </button>
                </div>
            </div>
            <Offcanvas
                show={show}
                onHide={handleClose}
                placement="bottom"
                className="submit-enquiry-offcanvas">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Get a Quote</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="form-section">
                    <img
                        // src={FormBg}
                        alt="" loading="lazy" />
                    <WebsiteForm />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}